import React from 'react';
import PropTypes from 'prop-types';
import { NumericFormat } from 'react-number-format';
import styled from 'styled-components';
import { FormGroup, FormGroupLabel, ErrorMessage, RequiredMark, BaseInputStyles } from './BaseInput'; // Styled NumericFormat seguindo o padrão visual do projeto

const StyledNumericFormat = styled(NumericFormat)`
  ${BaseInputStyles}
`;

const CurrencyInput = ({
  name,
  label,
  placeholder,
  value,
  onChange,
  disabled = false,
  required = false,
  error,
  input,
  meta,
  ...props
}) => {
  // Usar input.value e input.onChange se disponível (React Final Form)
  const fieldValue = input ? input.value : value;
  const fieldOnChange = input ? input.onChange : onChange;
  const fieldName = input ? input.name : name;
  return <FormGroup>
      {label && <FormGroupLabel>
          {label}
          {required && <RequiredMark>*</RequiredMark>}
        </FormGroupLabel>}
      <StyledNumericFormat name={fieldName} value={fieldValue || ''} onValueChange={values => {
      fieldOnChange(values.floatValue ?? '');
    }} thousandSeparator='.' decimalSeparator=',' prefix='R$ ' allowNegative={false} decimalScale={2} fixedDecimalScale placeholder={placeholder} disabled={disabled} {...props} />
      {(error || meta && meta.touched && meta.error) && <ErrorMessage>
          {error || meta.error}
        </ErrorMessage>}
    </FormGroup>;
};

CurrencyInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  error: PropTypes.string,
  input: PropTypes.object,
  meta: PropTypes.object
};
export default CurrencyInput;
